<div
  class="card-item-main"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + card().header"
>
  <ptl-card>
    <div class="card-item-main-cover" [style.background]="card().image ? null : gradient()">
      @if (card().image) {
        <ptl-card-image [src]="card().image" [alt]="card().header" [cardIndex]="cardIndex()"></ptl-card-image>
      } @else if (!card().started && !card().completed) {
        <div class="card-item-lock-icon">
          <ptl-icon [icon]="LucideLock" size="m"></ptl-icon>
        </div>
      }
    </div>

    <div class="card-item-main-content">
      <div class="card-item-meta-line">
        @if (card().v3CardType || card().collectionType) {
          <span class="card-item-type-badge" [ngClass]="typeColorClass()">{{ typeDisplayName() }}</span>
        }
        @if (timeText()) {
          <span class="card-item-meta-text">{{ timeText() }}</span>
        }
        @if (activitiesText()) {
          <span class="card-item-meta-text">{{ activitiesText() }}</span>
        }
      </div>

      <h3 class="card-item-title">{{ card().header }}</h3>

      @if (card().started || card().completed) {
        <div class="card-item-progress-section">
          <div class="card-item-progress-header">
            <span class="card-item-progress-label">Progress</span>
            <span class="card-item-progress-pct">{{ progressPct() }}%</span>
          </div>
          <div class="card-item-progress-track">
            <div class="card-item-progress-fill" [style.width.%]="progressPct()"></div>
          </div>
        </div>
      }
    </div>
  </ptl-card>
</div>
